const CircleIcon = (props: any) => {
  return (
    <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15" r="12.5" fill={props.bcolor ?? '#56c4c7'} stroke="#000" strokeWidth="1" />
    </svg>
  );
};

export default CircleIcon;
